import { Component, inject, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { UserService } from "src/app/services/user/user.service";

@Component({
  selector: "app-gift-coupon",
  templateUrl: "./gift-coupon.component.html",
  styleUrls: ["./gift-coupon.component.scss"],
})
export class GiftCouponComponent{
  userService = inject(UserService);
  nav = inject(NavController);


  constructor() {
    //this.getStoreBalance();
  }

  getStoreBalance() {
    // if (this.userService.user?.orwiPoints) {
    //   const storePoint = this.userService.user.orwiPoints.find(p => p.pointType === 'store');
    //   this.storeBalance = storePoint ? storePoint.balance : 0;
    // }
  }

  goTo() {
    if (this.userService.user.isVirtual) {
      this.nav.navigateForward("otp-request");
    } else {
      this.nav.navigateForward("reservations")
    }
  }
}
